import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {authService} from "../../../../../client/connection/Services";
import {collapseIframe} from "../../../../widget/misc/WidgetUtils";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {ADDRESS_PANEL_URL, PAYMENT_DETAILS_PANEL_URL} from "../../../PanelConstants";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {Controller} from "../../../Controller";
import {PANEL_TYPE} from "../../../../../blink-sdk/Constants";
import {iFrameState} from "../../../../services/IFrameState";


export class SubscribeReviewOrderPanelStyle extends BasePanelPageStyle {
    @styleRule
    reviewItem = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        marginBottom: 14,
    };

    @styleRule
    reviewItemTitleContainer = {
        display: "flex",
        justifyContent: "space-between",
    };

    @styleRule
    reviewItemDescription = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 4,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    nameOnAddress = {
        marginBottom: 4,
    };

    @styleRule
    addressDetails = {
        display: "flex",
        flexDirection: "column",
    };

    @styleRule
    lineSeparator = {
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
        marginBottom: 14
    }
}

@registerStyle(SubscribeReviewOrderPanelStyle)
export class SubscribeReviewOrderPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewOrder,
        };
    }

    render() {
        const {styleSheet} = this;
        const {panelType} = iFrameState;
        const shippingAddress = Controller.address.selectedAddress;
        const {selectedOffer, discountCode} = Controller.subscriptionPlan;
        const discountInfo = Controller.subscriptionPlan.getDiscountInfo(selectedOffer);
        const finalPrice = discountInfo ? selectedOffer.formatPrice(discountInfo.finalPrice) : "-";
        const cycle = selectedOffer.getCycleDuration(true);

        const addressLabel = panelType === PANEL_TYPE.giftSubscription ? Messages.recipientAddress : Messages.address;
        const paymentDescription = panelType === PANEL_TYPE.giftSubscription ? Messages.giftSubscriptionPaymentDescription : Messages.subscribePaymentDescription;

        return [
            <div className={styleSheet.reviewItem} testId="subscriptionPlanSection">
                <div className={styleSheet.reviewItemTitleContainer}>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <LinkButton
                        value={Messages.change}
                        testId="changeButton"
                        onClick={() => Controller.subscriptionPlan.enterChangePlan()}
                    />
                </div>
                <MessageElement className={styleSheet.reviewItemDescription}
                                args={[selectedOffer.coverage.name, finalPrice, cycle]}
                                message={Messages.subscriptionPlanDescription}/>
            </div>,
            discountCode && [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="discountSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{Messages.discountCode}</div>
                    </div>
                    <MessageElement
                        className={styleSheet.reviewItemDescription}
                        message={Messages.discountCodeApplied(discountCode)}
                    />
                </div>
            ],
            selectedOffer.shouldCollectAddress() ? [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="addressSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{addressLabel}</div>
                        <LinkButton
                            value={Messages.edit}
                            testId="editButton"
                            onClick={() => Router.changeURL(ADDRESS_PANEL_URL)} /* TODO Why is this just not the URL? */
                        />
                    </div>
                    <div className={styleSheet.reviewItemDescription}>
                        <div className={styleSheet.nameOnAddress}>{shippingAddress.getRecipientName()}</div>
                        <div className={styleSheet.addressDetails}>{shippingAddress}</div>
                    </div>
                </div>
            ] : null,
            <div className={styleSheet.lineSeparator}/>,
            <div className={styleSheet.reviewItem} testId="paymentMethodSection">
                <div className={styleSheet.reviewItemTitle}>{Messages.payment}</div>
                <MessageElement className={styleSheet.reviewItemDescription} args={[finalPrice, cycle]}
                                message={paymentDescription}/>
            </div>,
            <MerchantButton onClick={() => this.handlePrimaryButtonClick()} className={styleSheet.actionButton}>
                {Messages.continueToPayment}
            </MerchantButton>,
            <div onClick={() => Router.back()} className={styleSheet.backButton}>
                {Messages.back}
            </div>
        ];
    }

    handlePrimaryButtonClick() {
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    async onMount() {
        super.onMount();

        authService.onAuthenticationChange(() => {
            if (!authService.isAuthenticated()) {
                collapseIframe();
            }
        });
        this.attachListener(Controller.subscriptionPlan, () => this.redraw());
    }
}
